import React, { Component } from "react"
import "./testimonials.css"
import TestimonialSlider from "./testimonials-slider"

class Testimonials extends Component {
  render() {
    return (
      <section id="testimonials-section">
        <div className="container">
          <div className="row">
            <div className="col-12 about-pb">
              <div className="section-header">
                <h2 className="section-head-title m-0">Testimonials</h2>
              </div>
              <p className="lead text-center">
                Here are some of the thoughts from our clients about us, all the
                testimonial are from "fiverr.com".
                <br />
                Read why our clients are preferring us to develope their
                websites from us.
              </p>
            </div>
          </div>

          <div id="testimonials-slider" className="row">
            <div className="col-12">
              <TestimonialSlider />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Testimonials
